module.exports = __webpack_public_path__ + "5a38082afa4b631a3092f1a9bb3da052.png";